import { useLocation } from "react-router-dom";
import { getPatientProfile } from "../../../services/dynamicActionPlanApi";
import { useT } from "../../../i18n/useT";
import { Box, Tab } from "@mui/material";
import React, { useEffect, useState } from "react";
import "./historytab.scss";
import HistoryList from "./HistoryList";
import { getHistoryList } from "../../../services/websiteApi";
import { useDispatch } from "react-redux";
import { setAPILoader } from "../../../state/actions/globalAction";
import { userInfoFetch } from "../../../utlis/commonFunction";
import UserDetailsHeader from "../UserDetailsHeader";
import { useSection } from "../../../i18n/useSection";

import {
  getMeasurementModule,
  isStsEligible,
  STS_MODULE_ID,
} from "../../../utlis/measurementModules";

export const filterHistoryModules = (list, account) =>
  (list || []).filter(
    (item) =>
      getMeasurementModule(item.moduleId) &&
      (Number(item.moduleId) !== STS_MODULE_ID || isStsEligible(account)),
  );

const HistoryTab = () => {
  const { search } = useLocation();
  const query = new URLSearchParams(search);
  const targetId =
    query.get("seniorUuid") || query.get("seniorId") || userInfoFetch()?.id;
  const initialTab = query.get("historyStatus") === "failed" ? 1 : 0;
  const [value, setValue] = useState(initialTab);
  const [person, setPerson] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);
  const [attempt, setAttempt] = useState(0);
  const t = useT("mmtUserList");
  const { success, failed, inprogress } = useSection("history");
  const navTab = [success, failed, inprogress];

  const tabHandler = (newValue) => {
    setValue(newValue);
  };
  const dispatch = useDispatch();
  const [data, setData] = useState();

  useEffect(() => {
    let canceled = false;
    setValue(initialTab);
    setData(undefined);
    setPerson(null);
    setLoading(true);
    setError(false);
    if (!targetId) {
      setLoading(false);
      setError(true);
      return;
    }
    dispatch(setAPILoader(true));
    Promise.all([getHistoryList(targetId), getPatientProfile(targetId)])
      .then(([res, profile]) => {
        if (canceled) return;
        const raw = res?.data?.data;
        const fields = profile?.data ?? profile;
        const details = Array.isArray(fields)
          ? Object.fromEntries(
              fields.map((field) => [
                field.uniqueId ?? field.name,
                field.value,
              ]),
            )
          : fields || {};
        setPerson({
          ...details,
          id: targetId,
          first_name: details.first_name ?? details.firstName,
          last_name: details.last_name ?? details.lastName,
        });
        setData({
          success: filterHistoryModules(raw?.success),
          failed: filterHistoryModules(raw?.failed),
          inprogress: filterHistoryModules(raw?.inprogress),
        });
      })
      .catch(() => {
        if (!canceled) setError(true);
      })
      .finally(() => {
        if (!canceled) {
          setLoading(false);
          dispatch(setAPILoader(false));
        }
      });
    return () => {
      canceled = true;
      dispatch(setAPILoader(false));
    };
  }, [dispatch, targetId, initialTab, attempt]);

  return (
    <UserDetailsHeader person={person}>
      <Box className="history-nav-tab-box-wrapper">
        <Box className="history-nav-tab-menu-box">
          <div className="history-nav-tab-item-wrap">
            {navTab.map((item, index) => {
              return (
                <Tab
                  label={item}
                  key={index}
                  selected={value === index}
                  variant="fullWidth"
                  onClick={() => tabHandler(index)}
                  className={`history-nav-tab-menu-item ${value === index ? "selected" : ""}`}
                />
              );
            })}
          </div>
        </Box>
        {loading && <p role="status">{t("loading")}</p>}
        {error && (
          <div role="alert">
            <p>{t("history_unavailable")}</p>
            <button onClick={() => setAttempt((n) => n + 1)}>
              {t("retry")}
            </button>
          </div>
        )}
        {!loading && !error && value === 0 && (
          <div value="1" className="history-info-block">
            <HistoryList data={data?.success} />
          </div>
        )}
        {!loading && !error && value === 1 && (
          <div value="2" className="history-info-block">
            <HistoryList data={data?.failed} />
          </div>
        )}
        {!loading && !error && value === 2 && (
          <div value="2" className="history-info-block">
            <HistoryList data={data?.inprogress} />
          </div>
        )}
      </Box>
    </UserDetailsHeader>
  );
};

export default HistoryTab;
